import RequestForm from "../../../../core/model2/form/request-form"

import {BackGround} from "../../../../core/gd-app/panels/preferences-panel/settings-background/settings-background"
import {ColorPalette} from "../../../../core/fields3/color-coding/color-coding"

const debug = false
// const debug = "getFormBackgroundStyle"

export default function getFormBackgroundStyle(requestForm:RequestForm) {
    switch (requestForm.settings.background) {
        case BackGround.GRAY :
            return {
                backgroundColor: gd.skin.colors.lightColor({
                    colorNumber: 2,
                    corePalette: ColorPalette.GRAY
                })
            }
        case BackGround.WHITE:
            return {
                backgroundColor: gd.skin.colors.lightColor({
                    colorNumber: 0,
                    corePalette: ColorPalette.SYSTEM
                })
            }
        case BackGround.PALE :
            return {
                backgroundColor: gd.skin.colors.paleBGColor({
                    colorNumber: requestForm.settings.color,
                    corePalette: ColorPalette.CORE
                })
            }
    }
}